const PaceMakerType = Object.freeze({
  PACEMAKER: 'pacemaker',
  DEFIBRILATOR: 'defibrilator',
  NO: 'no',
})

export default PaceMakerType
